/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const FullscreenExit: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="fullscreen-exit" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M340 170V340H170V453.3333333333334H453.3333333333333V170H340zM906.6666666666666 170V453.3333333333334H1190V340H1020V170H906.6666666666666zM170 906.6666666666669V1020H340V1190H453.3333333333333V906.6666666666669H170zM906.6666666666666 906.6666666666669V1190H1020V1020H1190V906.6666666666669H906.6666666666666z" : "M272 136V272H136V362.6666666666667H362.6666666666667V136H272zM725.3333333333334 136V362.6666666666667H952V272H816V136H725.3333333333334zM136 725.3333333333333V816H272V952H362.6666666666667V725.3333333333333H136zM725.3333333333334 725.3333333333333V952H816V816H952V725.3333333333333H725.3333333333334z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
FullscreenExit.displayName = `Blueprint5.Icon.FullscreenExit`;
export default FullscreenExit;
